var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('h1',{staticClass:"app__logo"},[_vm._v("Did he really say that?")]),_c('p',{staticClass:"app__description"},[_vm._v("Swipe right for yes, left for no!")]),_c('DraggableImage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }